export enum Brand {
    KVERNELAND = 'kverneland',
    VICON = 'vicon'
}

interface NyrisBrandConfig {
    primaryColor: string;
    cameraIconColor: string;
    browseGalleryButtonColor: string;
    customerLogo: string;
    logoWidth: number;
    apiKey: string;
}

interface BrandConfig {
    name: string;
    displayName: string;
    nyris: NyrisBrandConfig;
    // Future brand-specific configurations can be added here
}

const brandConfigs: Record<Brand, BrandConfig> = {
    [Brand.KVERNELAND]: {
        name: Brand.KVERNELAND,
        displayName: 'MyKverneland',
        nyris: {
            primaryColor: '#006633',
            cameraIconColor: '#003552',
            browseGalleryButtonColor: '#003552',
            customerLogo: '/images/kverneland_logo_widget_256.png',//kverneland-nav-logo.png',
            logoWidth: 256,
            apiKey: 'GCbkPxVictbOBTP5oXdELLSoGAnagIXg'
        },
        // Future KVG-specific configurations will go here
    },
    [Brand.VICON]: {
        name: Brand.VICON,
        displayName: 'MyVicon',
        nyris: {
            primaryColor: '#003552',
            cameraIconColor: '#006633',
            browseGalleryButtonColor: '#006633',
            customerLogo: '/images/vicon_logo_widget_256.png',//vicon-brand-logo.png',
            logoWidth: 256,
            apiKey: '8ZDpEPj8qUSh3TKYvr00DojTjpCjGtQk'
        },
        // Future Vicon-specific configurations will go here
    }
};

// Helper function to determine current brand from runMode
const getCurrentBrand = (): Brand => {
    const runMode = process.env.REACT_APP_runMode;
    // If runMode is not set, default to VICON
    if (!runMode) {
        console.warn('REACT_APP_runMode not set, defaulting to VICON');
        return Brand.VICON;
    }

    // If runMode contains 'kvg', return KVG, otherwise VICON
    const brand = runMode.includes('kvg') ? Brand.KVERNELAND : Brand.VICON;
    console.log(`Determined brand: ${brand} from runMode: ${runMode}`);
    return brand;
};

/**
 * Gets the full brand configuration for the current environment.
 * @throws Error if the configuration is invalid or missing required fields.
 */
export const getBrandConfig = (): BrandConfig => {
    const currentBrand = getCurrentBrand();
    const config = brandConfigs[currentBrand];
    if (!config) {
        throw new Error(`Invalid brand configuration for ${currentBrand}`);
    }
    // Basic validation
    if (!config.nyris.apiKey) {
        throw new Error(`Missing required Nyris config for ${currentBrand}`);
    }
    return config;
};

/**
 * Gets the Nyris-specific configuration for the current brand.
 */
export const getNyrisBrandConfig = (): NyrisBrandConfig => {
    return getBrandConfig().nyris;
};

/**
 * Gets the current brand display name.
 */
export const getBrandDisplayName = (): string => {
    return getBrandConfig().displayName;
};

/**
 * Gets the current brand title.
 */
export const getBrandTitle = (capitalizeFirstLetter: boolean = true): string => {
    const brand = getCurrentBrand();
    return capitalizeFirstLetter
        ? brand.charAt(0).toUpperCase() + brand.slice(1)
        : brand;
};


// Type exports for use in other files
export type { NyrisBrandConfig };